import React from 'react';
import ReactDOM from 'react-dom';
import Confirm  from "../components/common/Confirm";

export default function(holderId){

  return function ModalUserConfirmation(message, callback) {
    const modalHolder = document.getElementById(holderId);
    ReactDOM.render((
        <Confirm message={message} hookToTop={false} callback={callback} />
    ), modalHolder);
  };
}